import WebSocketCustomLink from '@/api/apollo-client/WebSocketCustomLink';

export const wsLink = new WebSocketCustomLink({
  url: window.__pixelConfig.WS_API,
  on: {
    opened: socket => {
      console.log(socket);
    },
    connected: () => {
      console.log('connected');
    },
    connecting: () => {
      console.log('connecting');
    },
    closed: () => {
      console.log('closed');
    },
    message: msg => {
      console.log('message', msg);
    },
    ping: msg => {
      console.log('ping', msg);
    },
    pong: msg => {
      console.log('pong', msg);
    },
    error: err => {
      console.error(err);
    }
  },

  connectionParams: () => ({
    authorization: `Bearer ${localStorage.getItem('authToken')}`
  })
});
